var React = require('react');

function EmptyProfile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.828,5H16.9A5,5,0,0,0,7.1,5H6.171A5.132,5.132,0,0,0,1.023,9.513a5.063,5.063,0,0,0,1.823,4.369C4.556,15.328,5.6,16.213,6,18.121V22a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V18.121c.405-1.908,1.445-2.794,3.228-4.3a5.015,5.015,0,0,0,1.749-4.3A5.132,5.132,0,0,0,17.828,5ZM16,21H8V19h8Zm3.862-8.646c-1.653,1.4-3,2.534-3.641,4.646H7.779c-.647-2.113-2-3.255-3.716-4.709A2.976,2.976,0,0,1,3.013,9.7,3.119,3.119,0,0,1,6.171,7H8A1,1,0,0,0,9,6a3,3,0,0,1,6,0,1,1,0,0,0,1,1h1.828a3.119,3.119,0,0,1,3.159,2.7A3.024,3.024,0,0,1,19.862,12.354ZM13,9v5a1,1,0,0,1-2,0V9a1,1,0,0,1,2,0Zm4,1v3a1,1,0,0,1-2,0V10a1,1,0,0,1,2,0ZM9,10v3a1,1,0,0,1-2,0V10a1,1,0,0,1,2,0Z"}));
}

EmptyProfile.defaultProps = {"fill":"#000000","width":"800px","height":"800px","viewBox":"0 0 24 24"};

module.exports = EmptyProfile;

EmptyProfile.default = EmptyProfile;
